import IntegrationDebugger from "slotworks/debug/integration-debugger/integration-debugger";
import LayerDebugger from "slotworks/debug/menu/layer-debugger/layer-debugger";
import DebugTab from "slotworks/debug/menu/tabs/debug-tab";
import SmartUIDebugger from "slotworks/debug/smartui-debugger/smartui-debugger";
import { ForceList } from "../force-list";

export default class DebuggerTab extends DebugTab {
    private integrationDebugger: IntegrationDebugger;
    private smartUIDebugger: SmartUIDebugger;
    private layerDebugger: LayerDebugger;

    constructor(name: string, resultList?: ForceList) {
        super(name, resultList);

        this.integrationDebugger = new IntegrationDebugger();

        this.smartUIDebugger = new SmartUIDebugger();

        this.layerDebugger = new LayerDebugger();
    }

    public render(root: HTMLElement, hide: Function): void {
        this.addIntegrationDebugger(root);
        this.addSmartUIDebugger(root);
        this.addLayerDebugger(root);
    }

    private addIntegrationDebugger(root: HTMLElement) {
        const inputBtn = document.createElement("button");

        inputBtn.style.fontSize = "3vw";
        inputBtn.style.margin = "1vmax 1vw";
        inputBtn.style.borderRadius = "10px";
        inputBtn.style.width = "72vw";
        inputBtn.style.height = "10vmax";
        inputBtn.style.backgroundColor = "#ffffff";
        inputBtn.innerText = "INTEGRATION";
        inputBtn.style.outline = "none";
        inputBtn.style.cursor = "pointer";

        inputBtn.onclick = () => {
            this.integrationDebugger.toggle();
        };
        root.appendChild(inputBtn);
    }

    private addSmartUIDebugger(root: HTMLElement) {
        const inputBtn = document.createElement("button");

        inputBtn.style.fontSize = "3vw";
        inputBtn.style.margin = "1vmax 1vw";
        inputBtn.style.borderRadius = "10px";
        inputBtn.style.width = "72vw";
        inputBtn.style.height = "10vmax";
        inputBtn.style.backgroundColor = "#ffffff";
        inputBtn.innerText = "SMART UI";
        inputBtn.style.outline = "none";
        inputBtn.style.cursor = "pointer";

        inputBtn.onclick = () => {
            this.smartUIDebugger.toggle();
        };
        root.appendChild(inputBtn);
    }

    private addLayerDebugger(root: HTMLElement) {
        const inputBtn = document.createElement("button");

        inputBtn.style.fontSize = "3vw";
        inputBtn.style.margin = "1vmax 1vw";
        inputBtn.style.borderRadius = "10px";
        inputBtn.style.width = "72vw";
        inputBtn.style.height = "10vmax";
        inputBtn.style.backgroundColor = "#ffffff";
        inputBtn.innerText = "LAYERS";
        inputBtn.style.outline = "none";
        inputBtn.style.cursor = "pointer";

        inputBtn.onclick = () => {
            this.layerDebugger.toggle();
        };
        root.appendChild(inputBtn);
    }
}
